import React, {useState, useRef, useEffect} from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { renderHeaderEditor } from '../../../helpers/editorToolbar';
import { Editor } from 'primereact/editor';
import performanceService from '../../../services/data/performance.service';
import konvivaService from '../../../services/data/konviva.service';
import { Dropdown } from 'primereact/dropdown';
import * as Yup from 'yup';



export default function FormCreateActionPlan(props) {
    
    const toast = useRef(null);
    const headerEditor = renderHeaderEditor();
    const [obj, setObj] = useState('')
    const [_actionType] = useState('')
    const actionTypeList = [
        { name: 'Curso/Formação', code: 'CF' },
        { name: 'Projeto', code: 'PR' },
        { name: 'Trabalho', code: 'TR' },
        { name: 'Tarefa', code: 'TA' },
        { name: 'Outro', code: 'OU' }
    ]
    const [actionPlan, setActionPlan] = useState('')
    const [konvivaCoursesList, setKonvivaCoursesList] = useState('')
    const [konvivaCourseId, setKonvivaCourseId] = useState('')

    useEffect(() => {
        if(props.konvivaCourses && props.konvivaCourses.length > 0) {
            //getonly IDCurso and NomeCurso values
            const courses = props.konvivaCourses?.map(course => ({
                id: course.CODCurso,
                name: course.NomeCurso
            }))
            setKonvivaCoursesList(courses)
        }
    }, [props.konvivaCourses])

    useEffect(() => {
        if(props.obj) {
            setObj(props.obj)
        }
        if(props.actionPlan && props.actionPlan !== '' && typeof props.actionPlan === 'object') {
            setActionPlan(props.actionPlan)
        } else {
            // Reset actionPlan when currentQuestion changes and no specific actionPlan is selected
            setActionPlan('')
        }
    }, [props])

    // Reset form when currentQuestion changes
    useEffect(() => {
        if (obj && (!props.actionPlan || props.actionPlan === '')) {
            // Reset form values when question changes and no specific action plan is selected
            setActionPlan('')
        }
    }, [obj, props.actionPlan])
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            action: actionPlan?.action || '',
            actionType: actionPlan?.actionType || ''
        },
        validationSchema: Yup.object({
            action: Yup.string().nullable().required("Favor preencher o campo Plano de Ação"),
            actionType: Yup.string().nullable().required("Favor preencher o campo Tipo de Ação"),
        }),
        onSubmit: values => {

            let data = {
                company_id: localStorage.getItem("companyId"),
                employee_id: props.employee,
                assessment_id: obj.assessment,
                model: 'AssessmentQuestion',
                object_id: obj.id,
                action: values.action,
                actionType: values.actionType,
            }

            if(konvivaCourseId) {
                data.konviva_course_id = konvivaCourseId
            }

            if(actionPlan && actionPlan.id) {
                data.id = actionPlan.id

                performanceService.updateActionPlan(data).then(() => {
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Plano de Ação atualizado com sucesso', life: 3000 });
                    props.listItems()

                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data[0], life: 4000 });
                });
                
            } else {
                performanceService.createActionPlan(data).then(() => {
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Plano de Ação criado com sucesso', life: 3000 });
                    props.listItems()
                    
                    //matricular aluno no konviva
                    if(konvivaCourseId) {
                        matricularAlunoNoKonviva()
                    }

                    formik.resetForm()

                    //close offcanvas
                    setTimeout(() => {
                        props.hideOffCanvas()
                    }, 3000);

                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data[0], life: 4000 });
                })
                
            }
            
        },
    });

    function matricularAlunoNoKonviva() {
        konvivaService.matricularAluno({ curso_id: konvivaCourseId, employee_id: props.employee }).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Aluno matriculado no Konviva com sucesso', life: 3000 });
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error?.response), life: 4000 });
        }).finally(() => {
            setKonvivaCourseId('')
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>

            <Toast ref={toast} position="top-right" />

            <div className="my-3">
                <label className="form-label fw-bold">Plano de Ação <span className="text-danger">*</span></label>
                <Editor
                    name="action"
                    style={{ height: '120px' }}
                    headerTemplate={headerEditor}
                    value={formik.values.action}
                    onTextChange={(e) => {
                        formik.setFieldValue('action', e.htmlValue);
                    }}
                />
                {formik.errors.action ? (<span name="action" className="text-vermelho">{formik.errors.action}</span>) : null}
            </div>

            <div className='my-3'>
                <label className="form-label fw-bold">Tipo de Ação <span className="text-danger">*</span></label>
                <div className='p-inputgroup'>
                    <Dropdown name='actionType' placeholder="Selecionar" value={formik.values.actionType} optionLabel="name" optionValue="code" options={actionTypeList} onChange={(e) => {formik.setFieldValue('actionType', e.value)} } className="rounded" />
                </div>
                {formik.errors.actionType ? (<span name="actionType" className="text-vermelho">{formik.errors.actionType}</span>) : null}
            </div>

            {
                formik.values.actionType === 'CF' && konvivaCoursesList && !actionPlan ?
                <div className='my-3'>
                    <label className="form-label fw-bold">Selecionar curso no Konviva</label>
                    <div className='p-inputgroup'>
                        <Dropdown showClear filter name='konvivaCourse' placeholder="Selecionar" value={konvivaCourseId} optionLabel="name" optionValue="id" options={konvivaCoursesList} onChange={(e) => {setKonvivaCourseId(e.value)}} className="rounded" appendTo="self" />
                    </div>
                    {formik.errors.konvivaCourse ? (<span name="konvivaCourse" className="text-vermelho">{formik.errors.konvivaCourse}</span>) : null}
                </div>
                :
                null
                
            }
            
            <div className="d-grid mx-auto btnMargin">
                <button className="btn btn-success btn-sm btn-rounded" type="submit">
                {
                    props.actionPlan && props.actionPlan.id ?
                    <>Atualizar</>
                    :
                    <>Adicionar</>
                }
                </button>
            </div>
        </form>
    )
}